/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { Switch } from 'antd'
import React from 'react'
import Text from '../Text'
import colors from '@sportninja/common/constants/appColors'

type SwitchInputProps = {
  title: string
  subtitle?: string | React.ReactNode
  value: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
  titleColor?: string
  subtitleColor?: string
  switchColor?: string
  selectorColor?: string
  /** Tab index for keyboard navigation */
  tabIndex?: number
}

export const SwitchInput: React.FC<SwitchInputProps> = ({
  title,
  subtitle,
  value,
  onChange,
  disabled,
  titleColor = colors.WHITE,
  subtitleColor = colors.NEUTRAL_50,
  switchColor = colors.PRIMARY,
  selectorColor = colors.WHITE,
  tabIndex,
}) => {
  return (
    <>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1 0 0;
          opacity: ${disabled ? 0.45 : 1};
        `}
      >
        <Text variant='paragraphSmall' weight='regular' color={titleColor}>
          {title}
        </Text>
        {subtitle ? (
          <Text
            variant='paragraphXSmall'
            weight='regular'
            color={subtitleColor}
          >
            {subtitle}
          </Text>
        ) : null}
      </div>
      <Switch
        onChange={onChange}
        value={value}
        size='small'
        css={css`
          align-self: center;
          &.ant-switch-checked {
            background-color: ${switchColor} !important;
          }
          &.ant-switch-checked:hover:not(.ant-switch-disabled) {
            background-color: ${switchColor} !important;
            opacity: 0.8;
          }
          &.ant-switch-checked:focus {
            background-color: ${switchColor} !important;
          }
          .ant-switch-handle::before {
            background-color: ${selectorColor} !important;
          }
          &.ant-switch-checked .ant-switch-handle::before {
            background-color: ${selectorColor} !important;
          }
          &.ant-switch-disabled {
            opacity: 0.25;
          }
        `}
        disabled={disabled}
        tabIndex={tabIndex}
      />
    </>
  )
}
